import {WmFeature} from '@wm-types/feature';
import {Point} from 'geojson';
import {createReducer, on} from '@ngrx/store';
import {
  loadEcPoisSuccess,
  ecTracksFailure,
  ecTracksSuccess,
  ecTracksInitAggregationsSuccess,
  loadCurrentEcTrackSuccess,
  loadCurrentEcTrackFailure,
  ecTracks,
  currentEcRelatedPoiId,
  currentEcPoiId,
  currentEcImageGalleryIndex,
} from '@wm-core/store/features/ec/ec.actions';

import {Hit} from '@wm-types/elastic';
import {LineString} from 'geojson';
import {Aggregations} from '@wm-types/elastic';

export const searchKey = 'search';
export interface Ec {
  ecPoiFeatures?: WmFeature<Point>[];
  hits?: Hit[];
  ecTracksLoading: boolean;
  aggregations?: Aggregations;
  initialAggregations?: Aggregations;
  currentEcTrack?: WmFeature<LineString>;
  currentEcPoiId?: number;
  currentEcPoi?: WmFeature<Point>;
  currentEcRelatedPoiId?: string;
  currentEcImageGalleryIndex?: number;
}
export interface ApiRootState {
  [searchKey]: Ec;
}

const initialConfState: Ec = {
  ecPoiFeatures: [],
  hits: [],
  ecTracksLoading: false,
};

export const ecReducer = createReducer(
  initialConfState,
  on(ecTracks, state => {
    return {
      ...state,
      ecTracksLoading: true,
    };
  }),
  on(ecTracksSuccess, (state, {response}) => {
    return {
      ...state,
      hits: response?.hits ?? [],
      aggregations: response?.aggregations ?? null,
      ecTracksLoading: false,
    };
  }),
  on(ecTracksInitAggregationsSuccess, (state, {response}) => {
    return {
      ...state,
      initialAggregations: response?.aggregations ?? null,
    };
  }),
  on(ecTracksFailure, state => {
    return {
      ...state,
      ecTracksLoading: false,
    };
  }),
  on(loadEcPoisSuccess, (state, {featureCollection}) => {
    const ecPoiFeatures = featureCollection.features as WmFeature<Point>[];
    const newState: Ec = {
      ...state,
      ecPoiFeatures,
    };
    return newState;
  }),
  on(loadCurrentEcTrackSuccess, (state, {ecTrack}) => {
    const newState: Ec = {
      ...state,
      currentEcTrack: ecTrack,
    };
    return newState;
  }),
  on(loadCurrentEcTrackFailure, state => {
    const newState: Ec = {
      ...state,
      currentEcTrack: null,
    };
    return newState;
  }),
  on(currentEcRelatedPoiId, (state, {currentRelatedPoiId}) => {
    const newState: Ec = {
      ...state,
      currentEcRelatedPoiId: currentRelatedPoiId,
    };
    return newState;
  }),
  on(currentEcPoiId, (state, {currentEcPoiId}) => {
    const newState: Ec = {
      ...state,
      currentEcPoiId: +currentEcPoiId,
    };
    return newState;
  }),
  on(currentEcImageGalleryIndex, (state, {currentEcImageGalleryIndex}) => {
    const newState: Ec = {
      ...state,
      currentEcImageGalleryIndex: currentEcImageGalleryIndex,
    };
    return newState;
  }),
  on(currentEcImageGalleryIndex, (state, {currentEcImageGalleryIndex}) => {
    const newState: Ec = {
      ...state,
      currentEcImageGalleryIndex: currentEcImageGalleryIndex,
    };
    return newState;
  }),
);
